import Const from 'constants';

function redirectTo(url) {
    return {
        type: Const.ROUTING,
        payload: {
            method: 'replace',
            nextUrl: url,
        },
    };
}

export {redirectTo};
